export const DefaultPageUrl = '/';

export const LanguageReplacementKey = '{{Language}}';

export const DefaultRoute = `/${LanguageReplacementKey}`;

export const ApplicationRouter_PortalId = '{{PORTAL_ID}}';
